import QuestionProgress from '../api/questionProgress';
import { applicationApiExecute } from './applicationActions';

export const submitQuestionProgress = applicationApiExecute(QuestionProgress.submit);
